export const addDefaultUtmParams = (url: string): string =>
  `${url}?utm_source=internal&utm_medium=homepage`;
